





























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
@Component({
    name: 'TiandituPanel',
    mixins: [MapResolver],
})

export default class TiandituPanel extends Vue {
    @Injectable() public container!: Container;
    @Prop() public searchResultDatas: any;


    public type: any = 0;
        /*当前组件面板的数据*/
    public tiandituDataProps: any = this.searchResultDatas;

    /*当前选中的数据*/
    public curSelectedData: any = {
        index: '',
    };

    public pagerCount: any = 5;
    public searchResultPagination: any = {
        page_num: 1,
        page_size: 10,
    };
    public loading: any = true;
    public listTotal: any = 1;
    private tiandituDataPropsItem: any = {};
    private openPrivateList: any = 0;
    private openCityList: any = false;
    private preOpenPrivateList: any = 0;
    private fail: any = false;


    private  switchTypeFlag: any = false; // 类型type的切换标志
    constructor() {
        super();
    }

    @Watch('searchResultDatas')
        public handleResultData(val: any) {
        if (val.hasOwnProperty('status')) {
            this.type = 0;
            this.fail = true;
            return;
        }
        this.fail = false;
        if (val.tianditu.type === 4) {
            // 关闭结果组件面板
            this.$store.dispatch('searchStore/isShowSearchResultEmit', false);
            return;
        } else {
            this.loading = false;
            this.type = val.tianditu.type;
            switch (this.type) {
                case 2: // staSearch 聚合
                    this.tiandituDataProps = val.tianditu.statistics.admins;
                    break;
                case 3: // poiSearch 散点
                    this.tiandituDataProps = val.tianditu.pois;
                    const tiandituDataPropsAll = this.tiandituDataProps;
                    this.searchResultPagination.page_size = this.tiandituDataProps.length;
                    break;
            }
        }
        }

        public handleClickDataItemCluster(dataItem: any, dataIndex: any) {
            if (this.openCityList) {
                if (this.preOpenPrivateList !== dataIndex) {
                    this.openCityList = true;
                    this.preOpenPrivateList = dataIndex;
                } else {
                    this.openCityList = false;
                }
            } else {
                this.openCityList = true;
                this.preOpenPrivateList = dataIndex;
            }
            if (!dataItem.hasOwnProperty('child_admins')) {
                const cityBox = [];
                cityBox.push(dataItem);
                this.tiandituDataPropsItem = cityBox;
            } else {
                this.tiandituDataPropsItem = dataItem.child_admins;
            }
            this.openPrivateList = dataIndex;
        }

        public async handleClickDataItemPoint(data: any, dataIndex: any) {
            // 关闭结果组件面板
            this.$store.dispatch('searchStore/isShowSearchResultEmit', false);
            // 发射该条数据到附近信息面板
            this.$emit('messageDetailDataEmit', {data, dataIndex});


            // 设置高亮
            const component: any = await  this.getComponent();
            component.openPopup(data);
            component.highLight(data, dataIndex + 1);

        }

        /*翻页*/
        public handleCurrentChange(val: number) {
            this.searchResultPagination.page_num = val;
            this.loading = true;
            // 更新里列表信息
            // this.updatePageInfo(val);
        }


        private async handleClickDataItemClusterCity(dataItemCity: any, dataIndexCity: any) {
            // 加载地图组件
            const component: any = await this.getComponent();
            // 接入真实数据
            component.locate(dataItemCity.location);
            const opt = {
                keyword: this.$store.state.searchStore.commonKeyword,
                query_type: 2,
                region: dataItemCity.admin_code,
            };
            component.keywordSearch(opt).then((dataList: any) => {
                this.$emit('changeSearchResultDataEmit', dataList);
                this.switchTypeFlag = true;
            });

        }

        private updatePageInfo(pageNum: number) {
            const tiandituDataPropsAll = this.searchResultDatas.tianditu.pois;
            const pageSize = this.searchResultPagination.page_size;
            const currentNum = (pageNum - 1) * pageSize;
            this.tiandituDataProps = tiandituDataPropsAll.slice(currentNum, currentNum + pageSize);
        }


    private getComponent(moduleName: string = 'Search', componentName: string = 'POISearch') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }
}
